import { NgModule } from '@angular/core';
import { StatusApprovalsIconPipe } from './approvals-status/status-icon.pipe';
import { StatusApprovalsPipe } from './approvals-status/status-translate.pipe';
import { BadgePipe } from './badge.pipe';
import { CamelToKebabCasePipe } from './camel-to-kebab-case/camel-to-kebab-case.pipe';
import { ChangeCasePipe } from './change-case/change-case.pipe';
import { ConcatDateAndTimePipe } from './concat-date-and-time/concat-date-and-time.pipe';
import { CpfCnpjFormatPipe } from './cpf-cnpj-format/cpfCnpjFormat.pipe';
import { DeadlineTimePipe } from './deadline-time/deadline-time.pipe';
import { FilterPipe } from './filter.pipe';
import { FirstErrorPipe } from './first-error/first-error.pipe';
import { FirstNamePipe } from './firstName.pipe';
import { FormQuestionTypePipe } from './form-question-type/form-question-type.pipe';
import { FormatNameForFormsPipe } from './format-tooltip-value/format-tooltip-value.pipe';
import { FormatTypePipe } from './format-type.pipe';
import { FormatDurationPipe } from './formatDuration.pipe';
import { FromNowPipe } from './fromNow.pipe';
import { GetIconPipe } from './get-icon/getIcon.pipe';
import { GetByIdPipe } from './getById.pipe';
import { HtmlToPlaintextPipe } from './htmlToPlaintext.pipe';
import { HumanizeDurationSecondsPipe } from './humanize-duration-seconds/humanizeDurationSeconds.pipe';
import { HumanizeDurationPipe } from './humanizeDuration.pipe';
import { ImportStatusPipe } from './import-status/import-status.pipe';
import { ImportTypePipe } from './import-type/import-type.pipe';
import { KeysPipe } from './keys.pipe';
import { LabelsPipe } from './labels/labels.pipe';
import { TranslateDeadlineStatusPipe } from './maintenance-deadline-status/maintenance-deadline-status.pipe';
import { StatusMaintenancePipe } from './maintenanceStatus.pipe';
import { MapPipe } from './map/map.pipe';
import { MaxLengthPipe } from './maxLength.pipe';
import { NumberFormatPipe } from './number-format/numberFormat.pipe';
import { OrderPipe } from './orderBy.pipe';
import { PaymentStatusPipe } from './paymentStatus.pipe';
import { TranslatePendencyTreatmentStatusPipe } from './pendency-treatment-status/pendency-treatment-status.pipe';
import { PercentageDecreaseAndIncreasePipe } from './percentage-decrease-or-increase/percentageDecreaseOrIncrease.pipe';
import { PhoneFormatPipe } from './phone-format/phoneFormat.pipe';
import { ProductServiceMeasurePipe } from './product-service-measure/product-service-measure.pipe';
import { RecurrenceDescriptionHumanizerPipe } from './recurrence-description-humanizer/recurrence-description-humanizer.pipe';
import { RemainingTimePipe } from './remaining-time/remaining-time.pipe';
import { RemoveLocationNamePipe } from './removeLocationName.pipe';
import { StatusIconMaintenancePipe } from './status-icon-maintenance.pipe';
import { EnumPipe } from './status/status.pipe';
import { RemoveTimeSecondsPipe } from './time-remove-seconds/remove-time-seconds.pipe';
import { TimezoneDatePipe } from './timezone-date/timezone-date.pipe';
import { TranslateCountryCodePipe } from './translate-country-code.pipe';
import { TranslateStorageMovementTypePipe } from './translate-storage-movement-type/translate-storage-movement-type.pipe';
import { WarrantyStatusPipe } from './warraanty-status/warraanty-status.pipe';
import { WebhookAuthTypePipe } from './webhook-auth-type/webhook-auth-type.pipe';

@NgModule({
  declarations: [
    MapPipe,
    KeysPipe,
    EnumPipe,
    OrderPipe,
    BadgePipe,
    FilterPipe,
    GetByIdPipe,
    GetIconPipe,
    FromNowPipe,
    FirstNamePipe,
    ChangeCasePipe,
    ImportTypePipe,
    FirstErrorPipe,
    FormatTypePipe,
    ImportStatusPipe,
    DeadlineTimePipe,
    TimezoneDatePipe,
    NumberFormatPipe,
    CpfCnpjFormatPipe,
    PhoneFormatPipe,
    RemainingTimePipe,
    FormatDurationPipe,
    StatusApprovalsPipe,
    HtmlToPlaintextPipe,
    HumanizeDurationPipe,
    CamelToKebabCasePipe,
    WebhookAuthTypePipe,
    FormQuestionTypePipe,
    StatusMaintenancePipe,
    ConcatDateAndTimePipe,
    RemoveTimeSecondsPipe,
    FormatNameForFormsPipe,
    RemoveLocationNamePipe,
    StatusApprovalsIconPipe,
    TranslateCountryCodePipe,
    StatusIconMaintenancePipe,
    MaxLengthPipe,
    ProductServiceMeasurePipe,
    HumanizeDurationSecondsPipe,
    TranslateDeadlineStatusPipe,
    PercentageDecreaseAndIncreasePipe,
    RecurrenceDescriptionHumanizerPipe,
    TranslatePendencyTreatmentStatusPipe,
    TranslateStorageMovementTypePipe,
    WarrantyStatusPipe,
    LabelsPipe,
    PaymentStatusPipe
  ],
  imports: [],
  providers: [
    OrderPipe,
    StatusApprovalsPipe,
    StatusApprovalsIconPipe
  ],
  exports: [
    MapPipe,
    EnumPipe,
    KeysPipe,
    BadgePipe,
    OrderPipe,
    FilterPipe,
    GetByIdPipe,
    GetIconPipe,
    FromNowPipe,
    FirstNamePipe,
    ChangeCasePipe,
    FirstErrorPipe,
    FormatTypePipe,
    MaxLengthPipe,
    ImportTypePipe,
    ImportStatusPipe,
    RemainingTimePipe,
    TimezoneDatePipe,
    NumberFormatPipe,
    CpfCnpjFormatPipe,
    PhoneFormatPipe,
    DeadlineTimePipe,
    FormatDurationPipe,
    StatusApprovalsPipe,
    HtmlToPlaintextPipe,
    WebhookAuthTypePipe,
    FormQuestionTypePipe,
    CamelToKebabCasePipe,
    HumanizeDurationPipe,
    StatusMaintenancePipe,
    RemoveTimeSecondsPipe,
    ConcatDateAndTimePipe,
    RemoveLocationNamePipe,
    FormatNameForFormsPipe,
    StatusApprovalsIconPipe,
    TranslateCountryCodePipe,
    StatusIconMaintenancePipe,
    ProductServiceMeasurePipe,
    HumanizeDurationSecondsPipe,
    TranslateDeadlineStatusPipe,
    PercentageDecreaseAndIncreasePipe,
    RecurrenceDescriptionHumanizerPipe,
    TranslatePendencyTreatmentStatusPipe,
    TranslateStorageMovementTypePipe,
    WarrantyStatusPipe,
    LabelsPipe,
    PaymentStatusPipe
  ]
})
export class PipesModule {}
